<template>
  <div class="main-wrapper hotel-booking">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
            </div>
            <div class="inv-header-right">
              <div class="company-details">
                <div class="gst-details">
                  Address:
                  <span>15 Hodges Mews, High Wycombe HP12 3JL, United Kingdom.</span>
                </div>
                <div class="address-bg"></div>
              </div>
            </div>
          </div>
          <h2 class="hotel-name">Dreams Hotel</h2>
          <div class="hotel-info">
            <div class="hotel-booking-details">
              <div class="booked-info">
                <span>Arrival Date</span>
                <span>31-08-2022</span>
              </div>
              <div class="booked-info">
                <span>Rate per Day/Ro0m</span>
                <span>175</span>
              </div>
              <div class="booked-info">
                <span>No of Rooms</span>
                <span class="right-info">3</span>
              </div>
              <div class="booked-info">
                <span>Departure Date</span>
                <span>05-09-2022</span>
              </div>
              <div class="booked-info">
                <span>No of adults</span>
                <span>2</span>
              </div>
              <div class="booked-info">
                <span>Room No.s</span>
                <span class="right-info">181A, 182A</span>
              </div>
              <div class="booked-info">
                <span>Total No of Days</span>
                <span>2</span>
              </div>
              <div class="booked-info">
                <span>No of Childrens</span>
                <span>4</span>
              </div>
              <div class="booked-info">
                <span>Others</span>
                <span class="right-info">-</span>
              </div>
            </div>
            <div class="hotel-booking-address">
              <div class="invoice-to">
                <span>Billing To:</span>
                <div class="inv-to-address">
                  <span class="billing-name">Walter Roberson</span>
                  299 Star Trek Drive, Panama City, <br />
                  Florida, 32405,<br />
                  USA.
                </div>
              </div>
            </div>
          </div>
          <div class="service-details">
            <h4>Service Details:</h4>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="dates">DATE</th>
                    <th class="services">SERVICES</th>
                    <th class="charged-amount">CHARGED AMOUNT</th>
                    <th class="discount">DISCOUNT</th>
                    <th class="total">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>31-08-2022</td>
                    <td>Special Menu</td>
                    <td>
                      <div>$<span>200</span></div>
                    </td>
                    <td>
                      <div>$<span>60</span></div>
                    </td>
                    <td>
                      <div>$<span>150</span></div>
                    </td>
                  </tr>
                  <tr>
                    <td>1-09-2022</td>
                    <td>Special Menu</td>
                    <td>
                      <div>$<span>200</span></div>
                    </td>
                    <td>
                      <div>$<span>60</span></div>
                    </td>
                    <td>
                      <div>$<span>150</span></div>
                    </td>
                  </tr>
                  <tr>
                    <td>2-09-2022</td>
                    <td>Special Menu</td>
                    <td>
                      <div>$<span>200</span></div>
                    </td>
                    <td>
                      <div>$<span>60</span></div>
                    </td>
                    <td>
                      <div>$<span>150</span></div>
                    </td>
                  </tr>
                  <tr>
                    <td>3-09-2022</td>
                    <td>Special Menu</td>
                    <td>
                      <div>$<span>200</span></div>
                    </td>
                    <td>
                      <div>$<span>60</span></div>
                    </td>
                    <td>
                      <div>$<span>150</span></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="invoice-table-footer">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">TOTAL DISCOUNT</td>
                      <td class="">
                        <div>$ <span>200.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer table-total-item">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">TOTAL AMOUNT</td>
                      <td class="">
                        <div>$ <span>600.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h4>Room Details:</h4>
            <div class="table-responsive room-detail-table">
              <table>
                <thead>
                  <tr>
                    <th class="dates">RATE/DAY</th>
                    <th class="rooms">NO OF ROOMS</th>
                    <th class="description">DESCRIPTION</th>
                    <th class="charged-amount">AMOUNT</th>
                    <th class="discount">DISCOUNT</th>
                    <th class="total">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div>$<span>120</span></div>
                    </td>
                    <td class="text-center">3</td>
                    <td>Personnal</td>
                    <td>
                      <div>$<span>525</span></div>
                    </td>
                    <td>
                      <div>$<span>25</span></div>
                    </td>
                    <td>
                      <div>$<span>500</span></div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>$<span>155</span></div>
                    </td>
                    <td class="text-center">4</td>
                    <td>Trip</td>
                    <td>
                      <div>$<span>600</span></div>
                    </td>
                    <td>
                      <div>$<span>45</span></div>
                    </td>
                    <td>
                      <div>$<span>89,955</span></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="invoice-table-footer">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">TOTAL DISCOUNT</td>
                      <td class="">
                        <div>$ <span>70.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer subtotal">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">SUBTOTAL</td>
                      <td class="">
                        <div>$ <span>90,455</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">SERVICE CHARGES</td>
                      <td class="">
                        <div>$ <span>475</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer subtotal">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">SALES TAX</td>
                      <td class="">
                        <div>% <span>5</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer table-total-item">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">TOTAL AMOUNT</td>
                      <td class="">
                        <div>$ <span>600.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <ol>
              <li>Goods Once sold cannot be taken back or exchanged</li>
              <li>
                We are not the manufactures, company will stand for warrenty as per their
                terms and conditions.
              </li>
            </ol>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
